import { useTranslation } from 'react-i18next';
import HeroSection from './components/HeroSection';
import SearchBar from './components/SearchBar';
import CategoryGrid from './components/CategoryGrid';
import ArticleList from './components/ArticleList';

export default function Home() {
  const { t } = useTranslation();

  return (
    <main className="w-full">
      <HeroSection />
      <SearchBar />
      <CategoryGrid />
      <ArticleList />

      {/* Mission statement section */}
      <section className="w-full bg-background-100 py-16 md:py-20 px-4 md:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="bg-background-50 rounded-2xl border border-background-200/70 p-8 md:p-12 text-center">
            <div className="inline-flex items-center gap-2 bg-accent-500 text-white px-3 py-1 rounded-full text-xs font-medium mb-6">
              <i className="ri-star-fill text-xs" />
              <span>{t('siteName')}</span>
            </div>
            <blockquote className="font-heading text-lg md:text-2xl text-foreground-900 leading-relaxed mb-6">
              {t('homeMissionQuote')}
            </blockquote>
            <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
              {t('homeMissionDesc')}
            </p>
          </div>
        </div>
      </section>
    </main>
  );
}